import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '@clerk/clerk-react';

const PUBLIC_PATHS = [
  '/login',
  '/signup',
  '/clerk',
  '/email-unsubscribe',
  '/email-confirmed',
  '/campaign/invites'
];

const isPublicPath = (pathname: string) => {
  if (PUBLIC_PATHS.some((p) => p === pathname)) return true;
  if (pathname.startsWith('/auth/')) return true;
  if (pathname === '/campaign/error') return true;
  // 邀请列表页免登录查看
  if (pathname === '/campaign/invites') return true;
  // 详情页免登录查看
  if (pathname.startsWith('/campaign/invites/detail/')) return true;
  if (pathname.startsWith('/campaign/detail/')) return true;
  return false;
};

interface AuthGuardProps {
  children: React.ReactNode;
}

/**
 * 未登录时跳转到 /login，并携带当前路径为 redirect 参数
 * 需要重定向时不渲染子组件，避免先闪一下受保护页面再跳转
 */
const AuthGuard: React.FC<AuthGuardProps> = ({ children }) => {
  const { isLoaded, isSignedIn } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  const needRedirect =
    isLoaded && !isSignedIn && !isPublicPath(location.pathname);

  React.useEffect(() => {
    if (!needRedirect) return;

    const redirect =
      location.pathname + (location.search ? location.search : '');
    navigate('/login?redirect=' + encodeURIComponent(redirect), {
      replace: true
    });
  }, [needRedirect, location.pathname, location.search, navigate]);

  // 需要重定向时不渲染子组件，避免退出登录后页面闪烁
  if (needRedirect) {
    return null;
  }

  return <>{children}</>;
};

export default AuthGuard;
